import React from 'react'
import { useSelector } from 'react-redux'
import { selectAvailableFeaturesByPricingIds } from 'ducks/billing/selectors/selectAvailableFeaturesByPricingIds'
import { selectSupportsViewerAddonForPricingIds } from 'ducks/billing/selectors/selectSupportsViewerAddonForPricingIds'
import { usePricingChangeInfo } from 'ducks/billing/hooks'
import FeaturesView from './Features'
import RemovedView from './Removed'

const Features = ({
  newPricingIds: inputNewPricingIds,
  newBillingCycle,
  showOnlyRemoved,
  className,
}) => {
  const { planLimitsExceeded } = usePricingChangeInfo(
    inputNewPricingIds,
    newBillingCycle
  )
  const newFeatures = useSelector(state =>
    selectAvailableFeaturesByPricingIds(state, inputNewPricingIds)
  )
  const supportsViewerAddon = useSelector(state =>
    selectSupportsViewerAddonForPricingIds(state, inputNewPricingIds)
  )

  if (!planLimitsExceeded) return null

  if (showOnlyRemoved) {
    return (
      <RemovedView
        {...newFeatures}
        className={className}
        supportsViewerAddon={supportsViewerAddon}
      />
    )
  }
  return (
    <FeaturesView
      {...newFeatures}
      className="grui mt-10"
      supportsViewerAddon={supportsViewerAddon}
    />
  )
}

export default Features
